import AboutFAQ from './AboutFAQ.vue'

export default AboutFAQ
